import { gql } from "apollo-boost";

const FREEPASS_LOGIN = gql`
  mutation freepassLogin(
    $data: String
    $email: String!
    $origin: String!
    $recaptcha_token: String!
  ) {
    freepass_login(
      data: $data
      email: $email
      origin: $origin
      recaptcha_token: $recaptcha_token
    ) {
      __typename
      ... on Error {
        message
      }
      ... on AccountCreated {
        message
        token
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on PasswordRequiredToRegister {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on SSOUser {
        url
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on PasswordRequested {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on VerificationSent {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
    }
  }
`;

export default FREEPASS_LOGIN;
